import { render, staticRenderFns } from "./RmpDialog.vue?vue&type=template&id=8d5c50f2&scoped=true"
import script from "./RmpDialog.vue?vue&type=script&lang=js"
export * from "./RmpDialog.vue?vue&type=script&lang=js"
import style0 from "./RmpDialog.vue?vue&type=style&index=0&id=8d5c50f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5c50f2",
  null
  
)

export default component.exports